var React = require('react');

function IconTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2692 0.458562C10.5894 0.138165 11.1086 0.137977 11.429 0.458143C11.7494 0.778309 11.7496 1.29759 11.4294 1.61799L4.87076 8.18142C4.55051 8.5019 4.03107 8.50199 3.71071 8.18163L0.427804 4.89873C0.107523 4.57845 0.107523 4.05917 0.427805 3.73888C0.748087 3.4186 1.26737 3.4186 1.58765 3.73888L4.29042 6.44166L10.2692 0.458562Z","fill":"currentColor"}));
}

IconTick.defaultProps = {"width":"12","height":"9","fill":"currentColor","viewBox":"0 0 12 9"};

module.exports = IconTick;

IconTick.default = IconTick;
